
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/ellixi/cheongdam",
      function () {
        return require("private-next-pages/brands/ellixi/cheongdam.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/ellixi/cheongdam"])
      });
    }
  